import React, { useEffect, useState } from "react";
import "../style.scss";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { icon } from "@fortawesome/fontawesome-svg-core/import.macro";
import logo from "../img/logo.png";
import {
  addDoc,
  collection,
  doc,
  getDocs,
  query,
  setDoc,
  where,
} from "firebase/firestore";
import { db } from "../firebase/firebase";
import SideNav from "components/SideNav";
import { v4 } from "uuid";
import { Link, Routes, Route, useNavigate } from "react-router-dom";
import { getAuth, onAuthStateChanged } from "firebase/auth";

export default function CreateSession() {
  const [name, setName] = useState("");
  const [desc, setDesc] = useState("");
  const [amount, setAmount] = useState(0);
  const [repeat, setRepeat] = useState(1);
  const [restTime, setRestTime] = useState(0);
  const [time, setTime] = useState("");
  const [type, setType] = useState(0);
  const [selGroup, setSelGroup] = useState(null);
  const [groups, setGroups] = useState(null);

  const selPage = "sessions";

  const navigate = useNavigate();

  function handleKeyDown(e) {
    e.target.style.height = "inherit";
    e.target.style.height = `${e.target.scrollHeight}px`;
  }

  const handleChange = (event) => {
    const result = event.target.value.replace(/\D/g, "");
    setRepeat(result);
  };

  const handleChangeAmount = (event) => {
    const result = event.target.value.replace(/\D/g, "");
    setRestTime(result);
  };

  const loadPermission = async (urlVar) => {
    const q = query(collection(db, "users"), where("__name__", "==", urlVar));

    const querySnapshot = await getDocs(q);

    querySnapshot.forEach((doc) => {
      setGroups(doc.data().permission_groups);
      setSelGroup(doc.data().permission_groups[0]);
    });
  };

  useEffect(() => {
    const getUser = async () => {
      const auth = await getAuth();

      onAuthStateChanged(auth, (user) => {
        if (user) {
          loadPermission(user.uid);
        } else {
          window.location.replace("/");
        }
      });
    };
    getUser();
  }, []);

  const createSession = async () => {
    if (desc == "" || name == "" || name == "") {
      alert("Bitte geben sie alle Felder an.");
    } else {
      try {
        var dataName = name + "_" + v4();

        const docRef = doc(db, "workouts", dataName);

        var groupsSave = [];
        groupsSave.push(selGroup);

        await setDoc(docRef, {
          desc_de: desc,
          name_de: name,
          id: dataName,
          amount: 0,
          number: repeat,
          rest: restTime,
          time: time,
          type: type,
          permission_groups: groupsSave,
        }).then(() => {
          setTimeout(() => {
            var refString = "editsession?sessionid=" + dataName;
            window.location.replace(refString);
            alert(
              "Traingseinheit erstellt, füge der Trainingseinheit nun Übungen hinzu."
            );
          });
        });
      } catch (err) {
        alert("Error adding document: ");
        alert("" + err);
        console.error("Error adding document: ", err);
      }
    }
  };

  const Content = () => (
    <section className="home-section">
      <div className="text">Trainingseinheit erstellen</div>

      {/* Session Data */}
      <section
        style={{ backgroundColor: "#ecf5ff" }}
        className={"plan-data"}
        id="plan-data"
      >
        <div className="container">
          <h2>Gib Informationen über deine Trainingseinheit an</h2>
          <form className="contact-form">
            <p>Name</p>
            <input
              type="search"
              className="plan-name"
              placeholder="Name"
              id="plan-name"
              value={name}
              onChange={(evt) => {
                setName(evt.target.value);
              }}
            />
            <p>Beschreibung</p>
            <textarea
              onKeyDown={(keydown) => {
                handleKeyDown(keydown);
              }}
              value={desc}
              onChange={(evt) => {
                setDesc(evt.target.value);
              }}
              className="plan-desc"
              placeholder="Beschreibung"
              id="plan-desc"
            ></textarea>
            <p>Wiederholungen</p>
            <input
              type="number"
              key="quantitykey"
              min="1"
              max="99"
              value={repeat}
              onChange={handleChange}
              className="plan-weeks"
            />
            <p>{"Pause zwischen Wiederholungen (in Sekunden)"}</p>
            <input
              type="number"
              key="quantitykey"
              min="1"
              max="999"
              value={restTime}
              onChange={handleChangeAmount}
              className="plan-weeks"
            />
            <p>{"Dauer des Trainings (in Minuten)"}</p>
            <input
              type="search"
              className="plan-name"
              placeholder="Dauer"
              value={time}
              onChange={(evt) => {
                setTime(evt.target.value);
              }}
            />
            <p>Übungstyp</p>
            <select
              style={{
                padding: "8px",
                width: "100%",
                border: "1px solid #ced4da",
              }}
              id="plan-level"
              name="plan"
              value={type}
              onChange={(evt) => {
                setType(Number(evt.target.value));
              }}
            >
              <option value="0">Laufen</option>
              <option value="1">Intervall</option>
              <option value="2">Fordender Lauf</option>
              <option value="3">Kraft</option>
              <option value="4">Gemischt</option>
              <option value="5">Ausdauer</option>
            </select>

            <p>Gruppe</p>
            <select
              style={{
                padding: "8px",
                width: "100%",
                border: "1px solid #ced4da",
              }}
              id="plan-level"
              name="plan"
              value={selGroup}
              onChange={(evt) => {
                setSelGroup(evt.target.value);
              }}
            >
              {groups?.map((obj) => {
                return <option value={obj}>{obj}</option>;
              })}
            </select>
          </form>
          <div style={{ display: "flex" }} className="form-button">
            <button
              onClick={() => createSession()}
              className="btn submit-form"
              type="submit"
            >
              Erstellen
            </button>
            <div style={{ width: 10 }}></div>

            <button
              onClick={() => navigate(-1)}
              className="btn btn-gray submit-form"
              type="submit"
            >
              Abbrechen
            </button>
          </div>
        </div>
      </section>
    </section>
  );

  return (
    <>
      <head>
        <link
          href="https://unpkg.com/boxicons@2.0.7/css/boxicons.min.css"
          rel="stylesheet"
        />
      </head>

      {SideNav({
        Content,
        selPage,
      })}
    </>
  );
}
